import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';

class ParameterFiles {
	static getParameterFileListV2(assetId, timeStampFrom, timeStampTo) {
		const endpoint = formatEndpoint(endpoints.parameterFile.getListV2, { assetId });
		return RestManagerWithoutBaseUrl.post(endpoint, { timeStampFrom, timeStampTo });
	}

	static getParameterFileV2(fileId) {
		const endpoint = formatEndpoint(endpoints.parameterFile.downloadV2, { fileId });
		return RestManagerWithoutBaseUrl.get(endpoint);
	}


	static getChangedParameterFileListV2(assetId, from, to) {
		const endpoint = formatEndpoint(endpoints.parameterFile.changedParametersV2, { assetId, from, to });
		return RestManagerWithoutBaseUrl.get(endpoint);
	}

	static getParameterBackupTypes(assetId) {
		const endpoint = formatEndpoint(endpoints.parameterFile.getTypesV2, { assetId });
		return RestManagerWithoutBaseUrl.get(endpoint);
	}
}

export default ParameterFiles;
